"use strict";
var _a, _b;
Object.defineProperty(exports, "__esModule", { value: true });
exports.ACCOUNTS_API_BASE = void 0;
exports.ACCOUNTS_API_BASE = (_b = (_a = process.env.ACCOUNTS_API) !== null && _a !== void 0 ? _a : process.env.GATSBY_ACCOUNTS_API) !== null && _b !== void 0 ? _b : `https://accounts.httptoolkit.tech/api`;
//# sourceMappingURL=util.js.map